import * as React from "react";
const ArthaLink20x17Icon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={21}
    height={19}
    viewBox="0 0 21 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.3422 16.9227C16.2705 13.6563 13.6873 11.1099 10.4525 10.1715C7.1143 11.1457 4.4594 13.6959 3.36873 16.951L3.35407 16.995L1.91064 16.8139C2.03766 14.304 3.0453 12.0233 4.63432 10.2676L4.64101 10.2601C6.12997 8.61794 8.12808 7.43613 10.3899 6.95703C12.5137 7.4033 14.4067 8.45932 15.8693 9.92907L15.8932 9.98366L15.9096 10.0211L15.9745 10.0364C17.6929 11.8121 18.7926 14.1689 18.9352 16.7751L17.3586 16.9729L17.3422 16.9227Z"
      fill="url(#paint0_linear_750_17784)"
    />
    <g filter="url(#filter0_f_750_17784)">
      <path
        d="M2.71787 16.6664L2.95837 14.1004L3.21812 12.8733L3.73788 11.3192L4.40525 9.97628"
        stroke="#101828"
        strokeWidth={0.45627}
      />
    </g>
    <g filter="url(#filter1_f_750_17784)">
      <path
        d="M18.1204 16.6078L17.8677 13.9115L17.5947 12.6221L17.0485 10.989L16.3473 9.57779"
        stroke="#101828"
        strokeWidth={0.45627}
      />
    </g>
    <path
      d="M6.67602 2.03755C7.78501 1.18342 8.99843 0.49404 10.2896 0C11.5922 0.50073 12.8152 1.20194 13.9311 2.07203C16.0959 3.75992 17.8574 6.08301 19.0147 8.8092C19.447 9.82764 19.7949 10.9023 20.048 12.0211C20.364 13.4177 20.5322 14.8832 20.5322 16.394L20.5321 16.4398L20.5319 16.5058L20.5314 16.5761L18.9317 16.777L17.3453 16.9901V16.924C17.3481 16.8598 17.3506 16.7954 17.3528 16.7309C17.3551 16.6624 17.357 16.5939 17.3585 16.5253C17.3614 16.3941 17.3628 16.2625 17.3628 16.1305C17.2372 13.97 16.7249 11.9023 15.9186 10.0466C15.8825 9.9635 15.9342 10.0812 15.8784 9.95483C15.3826 8.83155 14.7788 7.7873 14.0877 6.84877C13.0358 5.42003 11.7818 4.23632 10.3992 3.39204C8.98255 4.23926 7.69916 5.42657 6.62946 6.86164C5.86463 7.88773 5.20907 9.04049 4.69219 10.2861L4.6897 10.2921C3.94855 12.0803 3.4931 14.0596 3.41054 16.1305C3.41054 16.4063 3.41687 16.6803 3.42932 16.9523L3.41472 16.9961L1.97724 16.8157L0.000740135 16.5675L0.000336425 16.5047C0.00013457 16.4678 0 16.4309 0 16.394C0 15.3046 0.0878743 14.2388 0.255885 13.2053C0.491921 11.7537 0.886009 10.3659 1.41709 9.06636C2.58428 6.21027 4.41269 3.78073 6.67602 2.03755Z"
      fill="white"
    />
    <path
      d="M6.67602 2.03755C7.78501 1.18342 8.99843 0.49404 10.2896 0C11.5922 0.50073 12.8152 1.20194 13.9311 2.07203C16.0959 3.75992 17.8574 6.08301 19.0147 8.8092C19.447 9.82764 19.7949 10.9023 20.048 12.0211C20.364 13.4177 20.5322 14.8832 20.5322 16.394L20.5321 16.4398L20.5319 16.5058L20.5314 16.5761L18.9317 16.777L17.3453 16.9901V16.924C17.3481 16.8598 17.3506 16.7954 17.3528 16.7309C17.3551 16.6624 17.357 16.5939 17.3585 16.5253C17.3614 16.3941 17.3628 16.2625 17.3628 16.1305C17.2372 13.97 16.7249 11.9023 15.9186 10.0466C15.8825 9.9635 15.9342 10.0812 15.8784 9.95483C15.3826 8.83155 14.7788 7.7873 14.0877 6.84877C13.0358 5.42003 11.7818 4.23632 10.3992 3.39204C8.98255 4.23926 7.69916 5.42657 6.62946 6.86164C5.86463 7.88773 5.20907 9.04049 4.69219 10.2861L4.6897 10.2921C3.94855 12.0803 3.4931 14.0596 3.41054 16.1305C3.41054 16.4063 3.41687 16.6803 3.42932 16.9523L3.41472 16.9961L1.97724 16.8157L0.000740135 16.5675L0.000336425 16.5047C0.00013457 16.4678 0 16.4309 0 16.394C0 15.3046 0.0878743 14.2388 0.255885 13.2053C0.491921 11.7537 0.886009 10.3659 1.41709 9.06636C2.58428 6.21027 4.41269 3.78073 6.67602 2.03755Z"
      fill="url(#paint1_linear_750_17784)"
    />
    <path
      d="M6.67602 2.03755C7.78501 1.18342 8.99843 0.49404 10.2896 0C11.5922 0.50073 12.8152 1.20194 13.9311 2.07203C16.0959 3.75992 17.8574 6.08301 19.0147 8.8092C19.447 9.82764 19.7949 10.9023 20.048 12.0211C20.364 13.4177 20.5322 14.8832 20.5322 16.394L20.5321 16.4398L20.5319 16.5058L20.5314 16.5761L18.9317 16.777L17.3453 16.9901V16.924C17.3481 16.8598 17.3506 16.7954 17.3528 16.7309C17.3551 16.6624 17.357 16.5939 17.3585 16.5253C17.3614 16.3941 17.3628 16.2625 17.3628 16.1305C17.2372 13.97 16.7249 11.9023 15.9186 10.0466C15.8825 9.9635 15.9342 10.0812 15.8784 9.95483C15.3826 8.83155 14.7788 7.7873 14.0877 6.84877C13.0358 5.42003 11.7818 4.23632 10.3992 3.39204C8.98255 4.23926 7.69916 5.42657 6.62946 6.86164C5.86463 7.88773 5.20907 9.04049 4.69219 10.2861L4.6897 10.2921C3.94855 12.0803 3.4931 14.0596 3.41054 16.1305C3.41054 16.4063 3.41687 16.6803 3.42932 16.9523L3.41472 16.9961L1.97724 16.8157L0.000740135 16.5675L0.000336425 16.5047C0.00013457 16.4678 0 16.4309 0 16.394C0 15.3046 0.0878743 14.2388 0.255885 13.2053C0.491921 11.7537 0.886009 10.3659 1.41709 9.06636C2.58428 6.21027 4.41269 3.78073 6.67602 2.03755Z"
      fill="url(#paint2_linear_750_17784)"
    />
    <defs>
      <filter
        id="filter0_f_750_17784"
        x={1.06488}
        y={8.44891}
        width={4.97053}
        height={9.66462}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation={0.712922}
          result="effect1_foregroundBlur_750_17784"
        />
      </filter>
      <filter
        id="filter1_f_750_17784"
        x={14.7171}
        y={8.05041}
        width={5.05628}
        height={10.0046}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation={0.712922}
          result="effect1_foregroundBlur_750_17784"
        />
      </filter>
      <linearGradient
        id="paint0_linear_750_17784"
        x1={10.4372}
        y1={14.2431}
        x2={10.5344}
        y2={6.9581}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0D41E1" />
        <stop offset={1} stopColor="#07C8F9" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_750_17784"
        x1={10.3414}
        y1={0.00000133414}
        x2={10.1324}
        y2={16.9953}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FC7C01" />
        <stop offset={0.699677} stopColor="#F76173" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_750_17784"
        x1={9.51828}
        y1={4.92047}
        x2={9.31178}
        y2={16.8301}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F15FAD" />
        <stop offset={0.6} stopColor="#F76173" />
      </linearGradient>
    </defs>
  </svg>
);
export default ArthaLink20x17Icon;
